import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { KPL_FINANCIAL_API } from "./apiRoutes";

const mutateAddKplFinancialReporting = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${KPL_FINANCIAL_API}/`, data);
};

const useAddKplFinancialReportingMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddKplFinancialReporting,
    ...queryParams,
  });

export default useAddKplFinancialReportingMutation;